module.exports = __webpack_public_path__ + "static/media/5. Speaker Denis Owens Ochieng.d61c596d.png";